import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Header, SecondaryHeader } from 'organisms/HeaderComponent';
import { useDispatch, useSelector } from 'react-redux';
import {
  getFooterData,
  getHeaderContentData,
  getHeaderData,
  getSetLocationBannerData,
  isCurrentPageRedirectFromRNA,
  isEmptyObject,
  isMobileDeviceOnly,
} from 'common/utilities/utils';
import { BannerData } from 'organisms/BannerComponent';
import { SetLocationBanner } from 'organisms/SetLocationBanner';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import { UserOrderContext } from 'context/context';
import { getCmsClient } from 'common/utilities/cmsClient';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import { ChannelManager } from 'common/manager';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import { ROUTE_URL, SET_LOCATION } from 'common/constants/SharedConstants';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { LOGIN_PATH_NAME } from '@kfc-global/react-shared/config/config.constants';
import HEADER_CONSTANT from 'organisms/HeaderComponent/AU/HeaderConstants/HeaderConstant';
import { HOME_PAGE_CONSTANT_DATA } from 'common/utilities/homePageModulator';
import { Footer } from 'organisms/FooterComponent';
import { checkIfCateringPage } from 'common/utilities/CateringPLPUtils';
import { isAddHopePurchase } from 'common/utilities/orderStatusUtils';

export const brazeCheck = () => {
  if (window.braze) {
    window.appboy = window?.braze;
  }
};

const RootHeaderContainer = ({ children }) => {
  const [showMainHeader, setShowMainHeader] = useState(true);
  const [showSecondaryHeader, setShowSecondaryHeader] = useState(false);
  const [showCheckoutHeader, setShowCheckoutHeader] = useState(false);
  const [showSmartBanner, setShowSmartBanner] = useState(false);
  const [showDispositionBar, setShowDispositionBar] = useState(true);
  const [showSetLocationBanner, setShowSetLocationBanner] = useState(false);
  const [showFooter, setShowFooter] = useState(true);
  const [showOrderSummaryHeader, setShowOrderSummaryHeader] = useState(false);
  const [showCateringDisposition, setShowCateringDisposition] = useState(false);
  const [isMobile, setMobileHeader] = useState(isMobileDeviceOnly(window.innerWidth));
  const [showBackToCart, setShowBackToCart] = useState(false);
  const [showNeedHelp, setShowNeedHelp] = useState(false);
  const [showMobileKfcLogo, setShowMobileKfcLogo] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    userOrderState: { hideDispositionBar = false, hideAccountPageHeaders = false, cmsInitialized, isPdpPageActive },
  } = useContext(UserOrderContext);

  const componentStateHandler = useCallback(
    pathname => {
      setShowMainHeader(false);
      setShowDispositionBar(false);
      setShowSecondaryHeader(false);
      setShowCheckoutHeader(false);
      setShowSmartBanner(false);
      setShowSetLocationBanner(false);
      setShowFooter(false);
      setShowCateringDisposition(false);
      setShowOrderSummaryHeader(false);
      setShowBackToCart(false);
      setShowNeedHelp(false);
      setShowMobileKfcLogo(false);
      if (isCurrentPageRedirectFromRNA({ pathname })) {
        setShowMainHeader(false);
        setShowDispositionBar(false);
        setShowFooter(false);
      } else if (pathname?.includes(ROUTE_URL.MENU_PAGE)) {
        setShowMainHeader(true);
        setShowDispositionBar(true);
        setShowSecondaryHeader(false);
        setShowCheckoutHeader(false);
        setShowSmartBanner(true);
        setShowSetLocationBanner(true);
        setShowFooter(true);
        setShowCateringDisposition(false);
        setShowOrderSummaryHeader(false);
        setShowBackToCart(false);
        setShowNeedHelp(false);
        setShowMobileKfcLogo(false);
      } else if (pathname?.includes(ROUTE_URL.CATERING_PAGE)) {
        setShowMainHeader(true);
        setShowDispositionBar(true);
        setShowSecondaryHeader(false);
        setShowCheckoutHeader(false);
        setShowSmartBanner(true);
        setShowSetLocationBanner(true);
        setShowFooter(true);
        setShowOrderSummaryHeader(false);
        setShowCateringDisposition(true);
        setShowBackToCart(false);
        setShowNeedHelp(false);
        setShowMobileKfcLogo(false);
      } else {
        switch (pathname) {
          case ROUTE_URL.CONTACT_KFC:
            setShowMainHeader(true);
            setShowDispositionBar(true);
            setShowFooter(true);
            break;
          case ROUTE_URL.CHECKOUT:
            setShowMainHeader(false);
            setShowDispositionBar(false);
            setShowSecondaryHeader(true);
            setShowCheckoutHeader(true);
            setShowSmartBanner(false);
            setShowSetLocationBanner(false);
            setShowFooter(false);
            setShowCateringDisposition(false);
            setShowOrderSummaryHeader(false);
            setShowBackToCart(true);
            setShowNeedHelp(true);
            setShowMobileKfcLogo(false);
            break;
          case ROUTE_URL.ORDER_SUMMARY:
            setShowMainHeader(false);
            setShowDispositionBar(false);
            setShowSecondaryHeader(true);
            setShowCheckoutHeader(false);
            setShowSmartBanner(false);
            setShowSetLocationBanner(false);
            setShowFooter(true);
            setShowCateringDisposition(false);
            setShowOrderSummaryHeader(true);
            setShowBackToCart(true);
            setShowNeedHelp(true);
            setShowMobileKfcLogo(false);
            break;
          case ROUTE_URL.ORDER_PROCESSING:
          case ROUTE_URL.PAYMENT_SUCCESS:
          case ROUTE_URL.PAYMENT_FAILURE:
          case ROUTE_URL.PAYMENT_STATUS_CHECK:
          case ROUTE_URL.ACTIVE_ORDERS:
            setShowMainHeader(false);
            setShowDispositionBar(false);
            setShowSecondaryHeader(true);
            setShowCheckoutHeader(isAddHopePurchase());
            setShowSmartBanner(false);
            setShowSetLocationBanner(false);
            setShowFooter(true);
            setShowCateringDisposition(false);
            setShowOrderSummaryHeader(false);
            setShowBackToCart(true);
            setShowNeedHelp(true);
            setShowMobileKfcLogo(isAddHopePurchase());
            break;
          case ROUTE_URL.HOME_PAGE:
          case ROUTE_URL.QR_HOMEPAGE:
            setShowMainHeader(true);
            setShowDispositionBar(true);
            setShowSecondaryHeader(false);
            setShowCheckoutHeader(false);
            setShowSmartBanner(true);
            setShowSetLocationBanner(true);
            setShowFooter(true);
            setShowCateringDisposition(false);
            setShowOrderSummaryHeader(false);
            setShowBackToCart(false);
            setShowNeedHelp(false);
            setShowMobileKfcLogo(false);
            break;
          case config(LOGIN_PATH_NAME):
            setShowMainHeader(false);
            setShowDispositionBar(false);
            setShowSecondaryHeader(false);
            setShowCheckoutHeader(false);
            setShowSmartBanner(false);
            setShowSetLocationBanner(false);
            setShowFooter(false);
            setShowCateringDisposition(false);
            setShowOrderSummaryHeader(false);
            setShowBackToCart(false);
            setShowNeedHelp(false);
            setShowMobileKfcLogo(false);
            break;
          case ROUTE_URL.ADD_HOPE:
          case ROUTE_URL.ADD_HOPE_THANK_YOU:
            setShowSecondaryHeader(true);
            setShowCheckoutHeader(true);
            setShowFooter(true);
            setShowBackToCart(false);
            setShowNeedHelp(false);
            setShowMobileKfcLogo(true);
            break;
          default:
            setShowMainHeader(true);
            setShowDispositionBar(!hideDispositionBar);
            setShowSecondaryHeader(false);
            setShowCheckoutHeader(false);
            setShowSmartBanner(false);
            setShowSetLocationBanner(true);
            setShowFooter(true);
            setShowOrderSummaryHeader(false);
            setShowCateringDisposition(false);
            setShowBackToCart(false);
            setShowNeedHelp(false);
            setShowMobileKfcLogo(false);
            break;
        }
      }
    },
    [hideDispositionBar],
  );

  const { headerData: { header = {}, showTimeslot, footer = {} } = {} } = useSelector(
    state => state?.marketConfigReducer?.response || {},
  );
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const tenantReducer = useSelector(state => state?.tenantReducer);
  const homePageContent = useSelector(state => state?.contentReducer?.response || {});
  const headerData = getHeaderData(header);
  const footerData = getFooterData(footer);
  const segmentedHomePageData = useMemo(() => getHeaderContentData(homePageContent), [homePageContent]);
  const homeContentfulResp = useSelector(data => data?.contentReducer?.response?.homeContentfulResp);
  brazeCheck();
  useEffect(() => {
    dispatch(
      getMarketConfigContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'marketConfig',
          'fields.channel': ChannelManager.channel,
          include: 5,
        },
      }),
    );
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams,
      }),
    );
    // }
  }, [dispatch, cmsInitialized, userParams]);

  useEffect(() => {
    const unListen = history.listen(location => {
      componentStateHandler(location?.pathname);
    });
    const locationPathName = history.location.pathname;
    componentStateHandler(locationPathName);
    return unListen;
  }, [componentStateHandler, history]);
  useEffect(() => {
    window.addEventListener('resize', () => {
      const isMobileView = isMobileDeviceOnly(window.innerWidth);
      setMobileHeader(isMobileView);
    });
  }, [isMobile]);

  const setLocationBannerComponent = () => {
    const setLocationBanner = homeContentfulResp?.filter(item => item?.fields?.title?.toUpperCase() === SET_LOCATION);
    if (setLocationBanner?.length) {
      const data = getSetLocationBannerData({ setLocationBanner });
      return <SetLocationBanner setLocationdata={data} />;
    }
  };
  const { DISPOSITION, PDP_DISPOSITION, CATERING_DISPOSITION } = HOME_PAGE_CONSTANT_DATA;

  const getDispositionData = () => {
    if (isPdpPageActive) {
      return segmentedHomePageData?.[PDP_DISPOSITION];
    } else if (showCateringDisposition) {
      return segmentedHomePageData?.[CATERING_DISPOSITION];
    } else {
      return segmentedHomePageData?.[DISPOSITION];
    }
  };

  const dispositionData = useMemo(
    () => getDispositionData(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      DISPOSITION,
      PDP_DISPOSITION,
      CATERING_DISPOSITION,
      isPdpPageActive,
      segmentedHomePageData,
      showCateringDisposition,
    ],
  );

  return (
    <>
      {showSmartBanner ? <BannerData /> : null}
      {(!isMobile || window.location.pathname !== ROUTE_URL.NUTRITION_ALLERGEN) &&
        showSetLocationBanner &&
        setLocationBannerComponent()}
      <div id={hideAccountPageHeaders ? 'header-container-hidden' : 'header-container'}>
        {headerData && showMainHeader ? <Header contentData={headerData} /> : null}
        {headerData && showSecondaryHeader ? (
          <SecondaryHeader
            contentData={headerData}
            checkoutHeader={showCheckoutHeader}
            showOrderSummaryHeader={showOrderSummaryHeader}
            showBackToCart={showBackToCart}
            showNeedHelp={showNeedHelp}
            showMobileKfcLogo={showMobileKfcLogo}
          />
        ) : null}
        {isMobile &&
          window.location.pathname === ROUTE_URL.NUTRITION_ALLERGEN &&
          showSetLocationBanner &&
          setLocationBannerComponent()}
        <StartOrderComponent
          contentData={{
            segmentedHomePageData: dispositionData ?? {},
            contentDispositionData: dispositionData ?? {},
          }}
          showCateringDisposition={checkIfCateringPage(history.location.pathname)}
          userParams={userParams}
          showHeader={showDispositionBar}
          hideTimeslot={showTimeslot?.toUpperCase() === HEADER_CONSTANT.STRING_NO}
        />
      </div>
      {children}
      {isEmptyObject(footerData) && showFooter ? (
        <Footer history={history} contentData={footerData} tenantReducerData={tenantReducer} />
      ) : null}
    </>
  );
};

export default RootHeaderContainer;
